/** Conductores cobre — R_ac a 75 °C (Ω/m) para cálculo de burden EMCALI. */
export type ConductorAwgEmcali = {
  awg: number;
  label: string;
  rAc75OhmPorM: number;
};

export const CONDUCTORES_AWG_EMCALI: ConductorAwgEmcali[] = [
  { awg: 14, label: "14 AWG", rAc75OhmPorM: 0.01045 },
  { awg: 12, label: "12 AWG", rAc75OhmPorM: 0.00673 },
  { awg: 10, label: "10 AWG", rAc75OhmPorM: 0.00411 },
  { awg: 8, label: "8 AWG", rAc75OhmPorM: 0.00259 },
  { awg: 6, label: "6 AWG", rAc75OhmPorM: 0.00163 },
];

export function getConductorAwg(awg: number): ConductorAwgEmcali | undefined {
  return CONDUCTORES_AWG_EMCALI.find((c) => c.awg === awg);
}

export const AWG_DEFAULT = 12;
